{
  "name": "micropad",
  "version": "4.7.0",
  "private": true,
  "scripts": {
    "preinstall": "python3 ../libs/build-libs.py && ./get_precache_files.py > src/extraPrecacheFiles.ts",
    "prestart": "tsgo -p _build/tsconfig.json",
    "start": "NODE_ENV='' node --experimental-import-meta-resolve _build/build.mjs",
    "prebuild": "tsgo -p _build/tsconfig.json",
    "build": "NODE_ENV=production node --experimental-import-meta-resolve _build/build.mjs",
    "test": "TZ=NZ jest",
    "typecheck": "tsgo --noEmit --p ./tsconfig.json",
    "typecheck:watch": "tsgo --noEmit --watch -p ./tsconfig.json",
    "lint": "eslint --flag unstable_ts_config src/",
    "lint:fix": "eslint --flag unstable_ts_config --fix src/"
  },
  "engines": {
    "node": ">=17.1.0"
  },
  "dependencies": {
    "@eslint/js": "^9.9.0",
    "@fontsource/abeezee": "^4.5.10",
    "@monaco-editor/react": "^4.6.0",
    "@nick_webster/photon": "^0.3.1",
    "@redux-devtools/extension": "^3.3.0",
    "@reduxjs/toolkit": "^1.9.7",
    "@sentry/integrations": "^7.114.0",
    "@sentry/react": "^7.118.0",
    "@sentry/tracing": "^7.114.0",
    "@types/eslint": "^9.6.0",
    "browserslist-useragent-regexp": "^4.1.3",
    "date-fns": "^2.30.0",
    "deep-freeze": "~0.0.1",
    "fend-wasm-web": "^1.5.1",
    "json-stringify-safe": "^5.0.1",
    "jszip": "^3.10.1",
    "localforage": "^1.10.0",
    "material-icons-font": "^2.1.0",
    "materialize-css": "^1.0.0",
    "monaco-editor": "~0.37.1",
    "mousetrap": "^1.6.5",
    "opus-recorder": "^4.1.4",
    "pdfobject": "^2.3.0",
    "re-resizable": "^6.9.17",
    "react": "^17.0.2",
    "react-dom": "^17.0.2",
    "react-draggable": "^4.4.6",
    "react-materialize": "^3.10.0",
    "react-redux": "^8.1.3",
    "react-select": "^5.8.0",
    "react-treeview": "~0.4.7",
    "redux": "^4.2.1",
    "redux-observable": "^2.0.0",
    "rxjs": "^7.8.1",
    "save-as": "^0.1.8",
    "semver": "^7.6.3",
    "showdown": "^1.9.1",
    "typescript": "~5.0.4",
    "typescript-fsa": "^3.0.0",
    "upad-parse": "^7.5.2",
    "vex-dialog": "^1.1.0",
    "vex-js": "^4.1.0",
    "workbox-core": "^6.6.1",
    "workbox-expiration": "^6.6.1",
    "workbox-precaching": "^6.6.1",
    "workbox-routing": "^6.6.1",
    "workbox-strategies": "^6.6.1"
  },
  "browserslist": {
    "production": [
      "chrome >= 84",
      "electron >= 12",
      "edge >= 80",
      "firefox >= 78",
      "safari >= 13.1",
      "ios_saf >= 13.4",
      "unreleased versions"
    ],
    "development": [
      "last 2 chrome version",
      "last 2 firefox version",
      "last 2 safari version",
      "last 2 electron version"
    ]
  },
  "devDependencies": {
    "@babel/core": "^7.25.2",
    "@babel/plugin-syntax-flow": "^7.24.7",
    "@babel/plugin-transform-react-jsx": "^7.25.2",
    "@eslint/eslintrc": "^3.1.0",
    "@sentry/esbuild-plugin": "^2.22.0",
    "@types/deep-freeze": "^0.1.5",
    "@types/eslint__js": "^8.42.3",
    "@types/html-minifier": "^4.0.5",
    "@types/jest": "^27.5.2",
    "@types/jest-image-snapshot": "^4.3.2",
    "@types/json-stringify-safe": "^5.0.3",
    "@types/mousetrap": "^1.6.15",
    "@types/node": "^18.19.44",
    "@types/react": "^17",
    "@types/react-dom": "^17.0.25",
    "@types/semver": "^7.5.8",
    "@types/showdown": "^1.9.4",
    "babel-eslint": "^10.1.0",
    "browserslist": "^4.23.3",
    "esbuild": "~0.16.17",
    "esbuild-plugin-browserslist": "~0.6.0",
    "esbuild-plugin-manifest": "~0.5.0",
    "eslint": "^9.9.0",
    "eslint-plugin-react": "^7.35.0",
    "expect-playwright": "^0.8.0",
    "globals": "^16.0.0",
    "html-minifier": "^4.0.0",
    "jest": "^27.5.1",
    "jest-circus": "^27.5.1",
    "jest-environment-node": "^27.5.1",
    "jest-image-snapshot": "^4.5.1",
    "jest-junit": "^13.2.0",
    "jest-playwright-preset": "^1.7.2",
    "jest-runner": "^27.5.1",
    "jiti": "^2.4.2",
    "playwright": "^1.46.0",
    "servor": "^4.0.2",
    "ts-jest": "^27.1.5",
    "typescript-eslint": "^8.1.0",
    "workbox-build": "^6.6.1",
	"@typescript/native-preview": "7.0.0-dev.20250809.1"
  },
  "resolutions": {
    "@types/react": "^17",
    "react": "^17",
    "redux": "^4",
    "rxjs": "^7.5.7",
    "internal-slot": "^1.0.5"
  },
  "packageManager": "yarn@1.22.22",
  "trustedDependencies": [
    "@sentry/cli"
  ]
}
